import { DateTime } from 'luxon';
import parsePhoneNumber from 'libphonenumber-js';

export function getFormattedDate(date?: string | null, format?: string) {
  if (!date) return '';

  const dateObject = DateTime.fromISO(date);

  return format
    ? dateObject.toFormat(format)
    : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dateObject.toLocaleString(DateTime.DATE_FULL);
}

/** Format phone number */
export function getFormattedPhone(value: any, isInternationslFormat?: boolean) {
  if (value) {
    const phoneNumber = parsePhoneNumber(`${value}`, 'US');

    const formatted = isInternationslFormat
      ? phoneNumber?.formatInternational()
      : phoneNumber?.formatNational();

    return formatted ?? value;
  }

  return value;
}

/** Capitalize the first letter of a string */
export const getCapitalizeFirstLetter = (
  string: string | null,
): string | null => {
  if (!string) {
    return '';
  }

  return string.charAt(0).toLocaleUpperCase() + string.slice(1);
};
